import { Component, Input } from '@angular/core';
import { ViewCompanyComponent } from 'components/company/viewcompany.component';
import { CompanyDomainsComponent } from 'components/hosting/company-domains/company-domains.component';
import { CompanySitesComponent } from 'components/hosting/company-sites/company-sites.component';
import { CredentialsDirective } from 'directives/credential.directive';
import { CredentialType } from 'enums/CredentialType';
import { CompanyDataProviderFactory } from 'services/company-data-provider';
import { DataTracking } from 'services/data-tracking';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';

@Component({
	selector: 'company-hosting',
	templateUrl: './company-hosting.component.html',
	providers: [CompanyDataProviderFactory, DataTracking],
	imports: [CompanySitesComponent, CredentialsDirective, CompanyDomainsComponent]
})
@ComponentUrl('company-hosting')
export class CompanyHostingComponent {

	private _companyId?: string;

	credentialTypeEnum = CredentialType;

	@UrlParam
	@Input()
	set companyId(id: string | undefined) {
		this._companyId = id;
		if (id) {

			this.dataProviderFactory.getProviderForCompanyId(id);
			this.navigation.openNavigationView(this, 'company-related-views', ViewCompanyComponent)
				.then(viewCompany => {
					viewCompany.companyId = id;
				});
		}
	}
	get companyId() {
		return this._companyId;
	}

	constructor(private readonly navigation: NavigationService, private readonly dataProviderFactory: CompanyDataProviderFactory) {
	}
}
